var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-wrapper"},[_c('div',{staticClass:"position-relative"},[(_vm.preloader)?_c('app-overlay-loader'):_vm._e(),_vm._v(" "),_c('app-hotel-share',{attrs:{"is_dashboard":true}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }